import { MainIcon } from "../../../../shared/components/MainIcon/MainIcon";
import styles from "./NavBar.module.css";
import { ReactComponent as DownloadIcon } from "../../../../../assets/icons/ic_download.svg";
import { useWidth } from "../../../../hooks/useWidht";
import { Modal } from "../../../../shared/components/Modal/Modal";
import { useState } from "react";
import { PrivacyPoliteModal } from "../PrivacyPoliteModal/PrivacyPoliteModal";
import { ANDROID_DOWNLOAD_LINK, ANDROID_DOWNLOAD_NAME } from "../../../../config/constants/download_link";

export const NavBar = () => {
    const width = useWidth();
    const isMobile = width < 768;
    const [open, setOpen] = useState(false);
    return (
        <div className={styles.navContainer}>
            <div className={styles.navLogo}>
                <MainIcon imagotype={true} iconSize={42} />
            </div>

            <div className={styles.navLinks}>
                {!isMobile && (
                    <a href="#" onClick={() => setOpen(true)}>
                        Política de privacidad
                    </a>
                )}
                <a href={ANDROID_DOWNLOAD_LINK} download={ANDROID_DOWNLOAD_NAME} className={styles.downloadButton} target="_blank">
                    {!isMobile && "Descargar"}
                    {isMobile && (
                        <DownloadIcon className={styles.downloadIcon} />
                    )}
                </a>
            </div>
            <PrivacyPoliteModal isOpen={open} onClose={() => setOpen(false)} />
        </div>
    );
};
